'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _radium = require('radium');

var _radium2 = _interopRequireDefault(_radium);

var _Constants = require('../Constants');

var _Constants2 = _interopRequireDefault(_Constants);

var _angleLeft = require('react-icons/lib/fa/angle-left');

var _angleLeft2 = _interopRequireDefault(_angleLeft);

var _angleRight = require('react-icons/lib/fa/angle-right');

var _angleRight2 = _interopRequireDefault(_angleRight);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

// icons


// this handles the rendering part of the buttons that appear on either side of
// the timeline.

/**
 * These are the static styles for the buttons on either side of the timeline.
 *
 * @param {styles} styles The user-definded styles/the default styles
 * @param {boolean} active Hacky crap to get svg filling color right
 * @return {object} An object containing styles for the buttons
 * link: styles defined for the link elements i.e. the href tag.
 * icon: styles defined for the icon that appears on the button.
 * inactive: styles defined for when the icons are inactive.
 */
var buttonStyles = {
  link: function link(_ref) {
    var outline = _ref.outline;
    return {
      position: 'absolute',
      top: '49px',
      bottom: 'auto',
      transform: 'translateY(-50%)',
      height: 34,
      width: 34,
      borderRadius: '50%',
      border: '2px solid ' + outline,
      overflow: 'hidden',
      textIndent: '100%',
      whiteSpace: 'nowrap',
      transition: 'border-color 0.3s'
    };
  },
  icon: function icon(styles, active) {
    return {
      position: 'absolute',
      left: 0,
      top: '50%',
      bottom: 'auto',
      transform: 'translateY(-50%)',
      height: 20,
      width: 29,
      overflow: 'hidden',
      textIndent: '100%',
      whiteSpace: 'nowrap',
      fill: active ? styles.foreground : styles.outline
    };
  },
  inactive: function inactive(styles) {
    return {
      color: styles.outline,
      cursor: 'not-allowed',
      ':hover': {
        border: '2px solid ' + styles.outline
      }
    };
  },
  active: function active(styles) {
    return {
      cursor: 'pointer',
      ':hover': {
        border: '2px solid ' + styles.foreground,
        color: styles.foreground
      }
    };
  }
};

/**
 * Markup for both the buttons (that translate the timeline left or right).
 *
 * @param  {object} props The info provided by the parent
 * @return {StatelessFunctionalReactComponent} The Markup info for both the buttons
 */
var HorizontalTimelineButtons = function HorizontalTimelineButtons(props) {
  var buttonBackEnabled = Math.round(props.position) < 0;
  var buttonForwardEnabled = Math.round(props.position) > Math.round(props.maxPosition);

  return _react2.default.createElement(
    'ul',
    { className: 'buttons' },
    _react2.default.createElement(
      'li',
      {
        className: 'button-back ' + (buttonBackEnabled ? 'enabled' : 'disabled'),
        key: _Constants2.default.LEFT,
        onClick: function onClick() {
          return props.updateSlide(_Constants2.default.LEFT);
        },
        style: [buttonStyles.link(props.styles), buttonBackEnabled ? buttonStyles.active(props.styles) : buttonStyles.inactive(props.styles), _defineProperty({}, _Constants2.default.LEFT, 0)]
      },
      _react2.default.createElement(_angleLeft2.default, {
        style: buttonStyles.icon(props.styles, buttonBackEnabled)
      })
    ),
    _react2.default.createElement(
      'li',
      {
        className: 'button-forward ' + (buttonForwardEnabled ? 'enabled' : 'disabled'),
        key: _Constants2.default.RIGHT,
        onClick: function onClick() {
          return props.updateSlide(_Constants2.default.RIGHT);
        },
        style: [buttonStyles.link(props.styles), buttonForwardEnabled ? buttonStyles.active(props.styles) : buttonStyles.inactive(props.styles), _defineProperty({}, _Constants2.default.RIGHT, 0)]
      },
      _react2.default.createElement(_angleRight2.default, {
        style: buttonStyles.icon(props.styles, buttonForwardEnabled)
      })
    )
  );
};

// Expected propteries
HorizontalTimelineButtons.propTypes = {
  // The function to update the slide
  updateSlide: _propTypes2.default.func.isRequired,
  // Information about what portion of the timeline is visible between buttons
  position: _propTypes2.default.number.isRequired,
  // The user passed styles (has fields like foreground, background color etc.)
  styles: _propTypes2.default.object,
  // The maximum position that the timeline component can acuire, (on initial load will be null)
  maxPosition: _propTypes2.default.number
};

// Wrapping the buttons with Radium (so we get all the styling goodness)
exports.default = (0, _radium2.default)(HorizontalTimelineButtons);


//////////////////
// WEBPACK FOOTER
// ../react-template/lib/components/timeline/react-horizontal-timeline/Components/HorizontalTimelineButtons.js
// module id = 1150
// module chunks = 0